import { PaymentRequest } from "@omni/types/components/payment/paymentRequest.model";
import { PaymentMethodCode } from "@omni/types/components/payment/shared/enum/paymentMethodCode.enum";
import { Mollie } from "@omni/types/packages/mollie.types";
import { isDefined } from "@omni/utils/helper.utils";

import { PaymentMethodsConfig } from "@/components/Checkout/Payment/paymentMethods/paymentMethod/paymentMethods.config";

type CreateRedirectPaymentRequest = (
    paymentMethodCode: PaymentMethodCode
) => Promise<PaymentRequest>;
const createRedirectPaymentRequest: CreateRedirectPaymentRequest = async (
    paymentMethodCode
) => ({
    code: paymentMethodCode
});

type CreateIntegratedPaymentRequest = (
    mollie: Mollie,
    paymentMethodCode: PaymentMethodCode
) => Promise<PaymentRequest>;
const createIntegratedPaymentRequest: CreateIntegratedPaymentRequest = async (
    mollie,
    paymentMethodCode
) => {
    const { token, error } = await mollie.createToken();

    return isDefined(error) || !token
        ? Promise.reject(error)
        : Promise.resolve({
              code: paymentMethodCode,
              cardToken: token
          });
};

type CreatePaymentRequest = (
    mollie: Mollie,
    paymentMethodCode: PaymentMethodCode
) => Promise<PaymentRequest>;
export const createPaymentRequest: CreatePaymentRequest = async (
    mollie,
    paymentMethodCode
) =>
    PaymentMethodsConfig.tokenizable.includes(paymentMethodCode)
        ? createIntegratedPaymentRequest(mollie, paymentMethodCode)
        : createRedirectPaymentRequest(paymentMethodCode);
